import React from 'react';
import { User, UserRoleLabels, UserRole } from '../../types';
import { UsersIcon, EditIcon, SaveIcon, CancelIcon } from '../../components/icons/Icons';
import { MemberSearchSelect } from '../../components/common/MemberSearchSelect';
import { Avatar } from '../../components/common/Avatar';
import '../../components/common/MemberSearchSelect.css';
import { getUserName } from '../../data/mockData';

interface AssignedPersonnelCardProps {
  assignedTo: string[];
  techUsers: User[];
  isProjectManager: boolean;
  editingAssigned: boolean;
  draftAssigned: string[];
  onStartEditAssigned: () => void;
  onSaveAssigned: () => void;
  onCancelEditAssigned: () => void;
  onToggleAssignee: (uid: string) => void;
  onRemoveAssignee?: (uid: string) => void;
}

export const AssignedPersonnelCard: React.FC<AssignedPersonnelCardProps> = ({
  assignedTo,
  techUsers,
  isProjectManager,
  editingAssigned,
  draftAssigned,
  onStartEditAssigned,
  onSaveAssigned,
  onCancelEditAssigned,
  onToggleAssignee,
  onRemoveAssignee,
}) => {
  return (
    <div className="detail-card">
      <h3 className="detail-card-title">
        <UsersIcon />
        Assigned Personnel
        {isProjectManager && (
          <div className="action-btn-group ml-auto">
            {editingAssigned ? (
              <>
                <button className="action-icon-btn save" onClick={onSaveAssigned} title="Save"><SaveIcon /></button>
                <button className="action-icon-btn cancel" onClick={onCancelEditAssigned} title="Cancel"><CancelIcon /></button>
              </>
            ) : (
              <button className="action-icon-btn edit" onClick={onStartEditAssigned} title="Edit"><EditIcon /></button>
            )}
          </div>
        )}
      </h3>
      {editingAssigned ? (
        <div className="assign-edit-list">
          <MemberSearchSelect
            users={techUsers}
            selectedIds={draftAssigned}
            onToggle={onToggleAssignee}
            multiSelect={true}
            placeholder="Select team members..."
          />
        </div>
      ) : (
        <>
          {assignedTo.map(uid => {
            const user = techUsers.find(u => u.id === uid);
            const roleLabel = user ? (UserRoleLabels[user.role as UserRole] || user.role) : 'Member';
            return (
              <div key={uid} className="detail-field">
                <span className="field-label">{roleLabel}</span>
                <span className="field-value assigned-row">
                  <Avatar user={user} name={getUserName(uid)} size={28} className="assign-edit-avatar" />
                  {getUserName(uid)}
                  {isProjectManager && onRemoveAssignee && !editingAssigned && (
                    <button
                      className="assignee-remove-btn"
                      onClick={() => onRemoveAssignee(uid)}
                      title="Remove assignee"
                    >
                      &times;
                    </button>
                  )}
                </span>
              </div>
            );
          })}
          {assignedTo.length === 0 && (
            <div className="detail-field">
              <span className="field-label">&mdash;</span>
              <span className="field-value">No one assigned</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};
